import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

class BatchFileFormsRedirectButton extends Component {
  static propTypes = {
    batchId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]).isRequired,
    batchFileId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]).isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    title: '',
    className: '',
    disabled: false,
    batchFileId: null
  };

  onClick(history) {
    const { batchId, batchFileId } = this.props;
    let historyPathExtension = 'forms';
    if (batchFileId && batchFileId > 0) {
      historyPathExtension = `files/${ batchFileId }`;
    }

    history.push(`/batches/${ batchId }/${ historyPathExtension }`);
  }

  render() {
    const { content, className, title, disabled } = this.props;
    return <Route
      render={ ({ history }) => (
        <button
          type="button"
          className={ `btn btn-redirect ${ className }` }
          onClick={ () => this.onClick(history) }
          title={ title }
          disabled={ disabled }
        >
          { content }
        </button>
      ) }
    />;
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const BatchFileFormsButton = connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(BatchFileFormsRedirectButton);

export default BatchFileFormsButton;
